<!-- Main -->
<div id="main" class="wrapper style1">
  <div class="container">
    <div class="logo-center">
      <div>
        <img src="./assets/images/transparent background_Two.png" alt="" />
        <h3>January 2022</h3>
      </div>
    </div>
  </div>
</div>
